export enum EnumLikelihood {
  LOW,
  MEDIUM,
  HIGH,
}
